import script from "./TutorPaymentMethodPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorPaymentMethodPage.vue?vue&type=script&setup=true&lang=js"

import "./TutorPaymentMethodPage.vue?vue&type=style&index=0&id=cf740abc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf740abc"]])

export default __exports__